import React from 'react';
import {Preloader} from "react-materialize";

export class Loader extends React.Component {

    render() {
        return (
            <div className="loader-content">
                <Preloader size='big'/>
                <p className="message">{this.props.message}</p>
            </div>
        );
    }
}
